import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: null,
    authProcessing: false,
    wechatProfile: {},
    refreshTime: null
  },
  mutations: {
    setToken (state, token) {
      // 认证后需要跳转的页面
      state.token = token
    },
    setRefreshTime (state, refreshTime) {
      state.refreshTime = refreshTime
    },
    authProcessing (state, processing) {
      state.authProcessing = processing
    },
    setWechatProfile (state, wechatprofile) {
      state.wechatProfile = wechatprofile
    }
  }
})

export default store
